/// <reference types="../../../types/graphql.d.ts" />

import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router";

import ApolloProviderWithAuthToken from "./ApolloProviderWithAuthToken";
import GlobalStyle from "./GlobalStyle";
import AppComponent from "./domain/AppComponent";
import OverlayMenu from "./domain/OverlayMenu";
import Start from "./domain/Start";
import Unauthorized from "./domain/Unauthorized";
import applicationsConsole from "./features/applications";
import brandsConsole from "./features/brands";
import documentExportsConsole from "./features/document-exports";
import priceListsConsole from "./features/price-lists";
import productLinesConsole from "./features/product-lines";
import productsConsole from "./features/products";
import revitParametersConsole from "./features/revit-parameters";
import taxonomyConsole from "./features/taxonomy";
import Auth0ProviderWithNavigate, { protectedComponent } from "./infrastructure/auth0/Auth0ProviderWithNavigate";
import AuthCallback from "./infrastructure/auth0/AuthCallback";
import { I18nProvider } from "./infrastructure/i18n";

ReactDOM
    .createRoot(document.getElementById("root"))
    .render(
        <React.StrictMode>
            <GlobalStyle />
            <BrowserRouter>
                <I18nProvider>
                    <Auth0ProviderWithNavigate>
                        <ApolloProviderWithAuthToken>
                            <OverlayMenu />
                            <Routes>
                                <Route Component={ AuthCallback } path="auth/callback" />
                                <Route Component={ withAuthenticationRequired(Outlet) }>
                                    <Route Component={ Start } index />
                                    <Route Component={ protectedComponent(Outlet, () => <Navigate to="/unauthorized" />) }>
                                        { applicationsConsole }
                                        { brandsConsole }
                                        { revitParametersConsole }
                                    </Route>
                                    { productLinesConsole }
                                    { documentExportsConsole }
                                    { priceListsConsole }
                                    { productsConsole }
                                    { taxonomyConsole }
                                    <Route Component={ Unauthorized } path="unauthorized" />
                                    <Route Component={ protectedComponent(Outlet, () => undefined) } path=":appName">
                                        <Route Component={ AppComponent } index path="*" />
                                    </Route>
                                </Route>
                            </Routes>
                        </ApolloProviderWithAuthToken>
                    </Auth0ProviderWithNavigate>
                </I18nProvider>
            </BrowserRouter>
        </React.StrictMode>
    );
